import { render, staticRenderFns } from "./ProfileSidebar.vue?vue&type=template&id=602e2ea0"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports